import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import React from 'react';
import ButtonLink from './links/button-link';
import SecondaryButtonLink from './links/secondary-button-link';
import ScrollIndicator from './scroll-indicator';
import { mq } from './_shared/media';
import { StyledSection } from './_shared/styled-section';
import { StyledH1 } from './_shared/styled-headings';
import { StyledP } from './_shared/styled-headings';

const StyledHeroSection = styled(StyledSection)`
  min-height: calc(100vh - 4 * var(--header-height));
  position: relative;
  z-index: 1;
  padding: 0.5rem calc((var(--space) / 2)) 2rem;

  ${mq.gt.sm} {
    min-height: calc(100vh - var(--header-height));
  }
`;

const StyledTagline = styled(StyledH1)`
  font-size: 2rem;
  max-width: 14ch;
  line-height: 1.1;
  margin: 0 auto;
  color: var(--title-color);
  word-break: break-word;
  text-align: center;

  ${mq.gt.sm} {
    font-size: 72px;
    max-width: 14ch;
  }
`;
const StyledDescription = styled(StyledP)`
  padding: 0.5rem 0 1rem;
  max-width: 32ch;
  color: var(--title-color);

  ${mq.lt.sm} {
    font-size: 16px;
  }

  strong {
    color: var(--secondary-color);
  }
`;

const Buttons = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-column-gap: 1rem;

  ${mq.lt.sm} {
    grid-template-columns: repeat(1, 1fr);
    grid-row-gap: 1rem;
    min-width: 250px;
    padding-bottom: 2rem;
  }
`;

const Hero = ({ data }) => {
  const { tagline, ctaLink, ctaLabel, secondctaLabel, secondctaLink, summary } = data;

  return (
    <StyledHeroSection>
      <StyledTagline>{tagline}</StyledTagline>
      <StyledDescription dangerouslySetInnerHTML={{ __html: summary }} />
      <Buttons>
        <ButtonLink label={ctaLabel} link={ctaLink} />
        <SecondaryButtonLink label={secondctaLabel} link={secondctaLink} />
      </Buttons>
      <ScrollIndicator />
    </StyledHeroSection>
  );
};

Hero.propTypes = {
  data: PropTypes.object.isRequired,
};

export default Hero;
